import { Message, IMessage, MessageTextConverter } from "./Message";
import { useState, useContext } from "react";
import { AppContext } from '../ApplicationContext';

export interface IReplyButtonMessage extends IMessage {

    Body: string;
    Footer: string;
    Header: IMediaItemHeader;

    Buttons: IReplyButton[];

}

export interface IMediaItemHeader {
    Blob: string;
    MimeType:string;
    Preview:string;
    DisplayName:string;
}

/*
export interface IDocumentHeader  extends IMediaItemHeader {

}
*/

export interface IReplyButton {
    Id: string;
    Title: string;
}

export const ReplyButtonMessage = (props: IReplyButtonMessage) => {

    const context = useContext(AppContext);
    console.log("ReplyButtonMessage", {props:props});
    const [done, setDone] = useState(props.Valid);

     const documentIcon = (type)=> {
        switch(type){
                case "application/pdf":
                    return "doc-icon bi bi-filetype-pdf";
                case "application/doc":
                    return "doc-icon bi bi-filetype-doc";
                case "application/docx":
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return "doc-icon bi bi-filetype-docx";
                case "application/xls":
                    return "doc-icon bi bi-filetype-xls";
                case "application/xlsx":
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return "doc-icon bi bi-filetype-xlsx";
                case "application/ppt":
                    return "doc-icon bi bi-filetype-ppt";
                case "application/pptx":
                    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                    return "doc-icon bi bi-filetype-pptx";
                default:
                    return "bi bi-file";
                    }
    }

    const getHeader = (item: IMediaItemHeader) => {
    
        switch(item["$type"]) {

            case "Miles.Research.Dialogs.Document, Miles.Research.Dialogs":
                return <div className="document text-center"><a className="btn" href={item.Blob} target="_blank"><i className={documentIcon(item.MimeType)}></i></a><a className="btn btn-outline-secondary"  href={item.Blob} target="_blank"><i className="bi bi-download"></i>  </a></div>
                
            case "Miles.Research.Dialogs.Image, Miles.Research.Dialogs":
                return <div className="image"><img className="img-fluid" src={item.Blob} alt={ item.DisplayName  } /></div>

            case "Miles.Research.Dialogs.Audio, Miles.Research.Dialogs":
                            return <div className="audio"><audio controls autoPlay className="img-fluid"><source src={item.Blob} type={item.MimeType} /></audio></div>

            case "Miles.Research.Dialogs.Video, Miles.Research.Dialogs":
                            return <div className="video" ><video controls autoPlay className="img-fluid"><source src={item.Blob} type={item.MimeType} /></video></div>

            default:
                return <div className="alert alert-danger" role="alert">
                          {item["$type"]} is not yet supported.
                        </div>

        }

    }


    const onChose = async (item: IReplyButton) => {
        
        
        
        try {

           // context.connection.invoke("SendReplyButton", item).then((result)=>{console.log('SendReplyButton done', result)}, (err)=> {console.log({error:err})});
           await context.messenger.sendReplyButton(item);
           setDone(true);

        } catch (err) {
            console.error(err);
        }


    }
    

    return <Message  {...props}>
    
        { props.Header &&  <div className="row  p-3">

            {getHeader(props.Header)}

            </div>
        }
       
        {props.Body && props.Body  !== "" && <div className="row body p-3">
                <div className="col">
                    {MessageTextConverter.parse(props.Body)}
                </div> 
            </div>
       }
       {props.Footer && props.Footer  !== "" && <div className="row footer  p-3">
                <div className="col">
                {MessageTextConverter.parse(props.Footer)}
            </div> 
            </div>
       }


       { (!done) && <div className="row">
        <div className="btn-group">
            { props.Buttons["$values"].map( (item, idx) => <button type="button" className="btn btn-secondary" onClick={ async (e)=> await onChose(item) } >{MessageTextConverter.parse(item.Title)}</button> ) }
        </div>
       </div>
       }

    </Message>

}